<template>
  <div class="signet-h5">
    <!-- 头部导航 -->
    <Header type="h5" />
    <!-- Banner -->
    <Banner
      :isPcFlag="false"
      h5Title="签管一体化电子合同云平台"
      h5TitleSecond="从签到管，开箱即用"
      h5Desc="智能 好用 安全"
      :h5BgImg="h5BgImg"
      h5signetBtn="免费试用"
      class="h5-sempro-banner"
      @showSignetDialog="showSignetDialog"
      :landingPageName="landingPageName"
    />
    <!-- Banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- 表单弹框 -->
    <CoverForm :show="showForm" @close="handleClose" @msg="handleShowMsg" @submitSuccess="handleDialogFormSuccess" />
    <!-- Form提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- Form 成功弹框 -->
    <SuccessForm v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
    <!-- 产品介绍 -->
    <ProductPromotion
      :dataListContent="systemList"
      :dataListText="packageTitleData"
      @showDialog="showDialog"
      @OnlineConsultationClick="OnlineConsultationClick"
    />
    <!-- 批量发起 -->
    <div id="batch-content" class="batch-init-h5">
      <div class="batch-title">批量发起，批量审批签署</div>
      <div class="batch-desc">专业版及以上支持</div>
      <img src="../../assets/images/sem-pro/H5/batch_show.gif" alt="" />
      <div class="btns-box">
        <div class="btns">
          <div class="mfsy" @click="showDialog">免费试用</div>
          <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
        </div>
      </div>
    </div>
    <!-- api接口开放场景 -->
    <div id="interface-content" class="api-interface-h5">
      <div class="interface-title">API接口开放，系统快速对接</div>
      <div class="interface-desc">专业版及以上支持</div>
      <img src="../../assets/images/sem-pro/H5/api_interface.png" alt="" />
      <div class="btns-box">
        <div class="btns">
          <div class="mfsy" @click="showDialog">立即接入</div>
          <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
        </div>
      </div>
    </div>
    <!-- 高级版亮点 -->
    <PreHighLight :dataList="preHighLightList"></PreHighLight>
    <!-- 客户案例 -->
    <CustomerCase :dataList="customerCaseList"></CustomerCase>
    <!-- 底部客服热线 -->
    <div class="sales-hotline">
      <a class="title" href="tel:0571-85785223">销售热线：0571-85785223</a>
      <div class="zxzx" @click="showDialog">免费试用</div>
    </div>
    <div class="footer-btns">
      <div class="item" @click="OnlineConsultationClick">
        <img src="@/assets/images/sem618/customer.png" alt="" />
        <div>在线客服</div>
      </div>
      <a class="item" href="tel:0571-85785223">
        <img src="@/assets/images/sem618/phone.png" alt="" />
        <div>电话咨询</div>
      </a>
      <div class="item" @click="handleBackToTopClick">
        <img src="@/assets/images/sem618/backtop.png" alt="" />
        <div>返回顶部</div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer
      :hotline="pageConfig.footer.hotline"
      :other-line="pageConfig.footer.otherLine"
      :agreementLink="agreementLink"
      :friendLink="friendLink"
      :isPhone="true"
    />
  </div>
</template>

<script>
import '@/mixins/form/flexible'
import dataList from './dataList'
import pageConfig from '@/lib/pageConfig/index.js'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  mixins: [qiyuMixin],
  components: {
    Header: () => import('@/components/header/index.vue'),
    Banner: () => import('@/components/Banner.vue'),
    CoverForm: () => import('@/components/CoverForm.vue'),
    Footer: () => import('./components/FooterH5.vue'),
    Message: () => import('@/components/Message.vue'),
    SuccessForm: () => import('@/components/SuccessForm.vue'),
    ProductPromotion: () => import('./components/ProductPromotion.vue'),
    PreHighLight: () => import('./components/PreHighLightH5.vue'),
    CustomerCase: () => import('./components/CustomerCase.vue'),
  },
  data() {
    return {
      h5BgImg: require('@/assets/images/sem-pro/H5/banner/banner_bg.png'),
      bannerBottomData: dataList.bannerBottomData,
      packageTitleData: dataList.packageTitleData,
      systemList: dataList.systemList,
      preHighLightList: dataList.preHighLightListH5,
      productIntroductionList: dataList.productIntroductionList,
      productAdvantageList: dataList.productAdvantageList,
      applicationScenariosList: dataList.applicationScenariosList,
      systemIntegrationList: dataList.systemIntegrationList,
      customerCaseList: dataList.customerCaseList,
      agreementLink: dataList.agreementLink,
      friendLink: dataList.friendLink,
      message: {
        content: '',
        show: false,
      },
      pageConfig,
      // 成功的弹框
      showSuccessDialog: false,
      // 弹框
      showForm: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
    }
  },
  mounted() {
    this.addQiyuScript()
  },
  computed: {
    RoutingJudgment() {
      return window.location.hostname === 'guangzhou.esign.cn'
    },
  },
  methods: {
    touchStart(event) {
      event.preventDefault() // 通知 Web 浏览器不要执行与事件关联的默认动作
    },
    showSignetDialog() {
      this.showForm = true
      document.addEventListener('touchmove', this.touchStart, { passive: false })
      // if (this.isIOS && this.isUC) {
      //   document.addEventListener('touchmove', this.touchStart, { passive: false })
      // }
    },
    handleClose() {
      this.showForm = false
      document.removeEventListener('touchmove', this.touchStart, { passive: false })
      // if (this.isIOS && this.isUC) {
      //   document.removeEventListener('touchmove', this.touchStart, { passive: false })
      // }
    },
    handleShowMsg({ content }) {
      this.message.content = content
      this.message.show = true
    },
    handleDialogFormSuccess() {
      this.handleClose()
      this.showSuccessDialog = true
    },
    handleBackToTopClick() {
      window.scrollTo(0, 0)
    },
    handlePhoneClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
      }
      this.$tsignData.track('sign_olandingpage_phonecallconsult')
      this.$tsignData.track('click_phone_call')
    },
    showDialog() {
      this.showForm = true
      document.addEventListener('touchmove', this.touchStart, { passive: false })
    },
    // 在线咨询
    OnlineConsultationClick() {
      if (this.RoutingJudgment) {
        this.handleCustomerServiceBaiduClick({ templateId: 6641070 })
      } else {
        this.handleCustomerServiceClick({ entry: 'yinzhangsecordpage' })
      }
    },
  },
}
</script>
<style lang="less">
@base-scale: calc((100vw / 375));
.basisDisplay(@justify, @align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}

.columnDisplay(@justify, @align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.geetest_panelshowslide {
  width: 7.4133rem !important;
  height: 7.6rem !important;
  .geetest_slider_tip {
    font-size: 0.3733rem !important;
  }
  .geetest_logo {
    width: 0.2933rem !important;
    height: 0.2933rem !important;
  }
  .geetest_copyright_tip {
    font-size: 0.32rem !important;
  }
  .geetest_result {
    height: 0.7467rem !important;
    bottom: 0 !important;
  }
  .geetest_result_content {
    padding: 0.2667rem 0 !important;
    font-size: 0.3733rem !important;
  }
  .geetest_panel_success {
    padding: 1.0667rem 0 0 0 !important;
    height: 1.9467rem !important;
  }
  .geetest_panel_success_box {
    width: 0.64rem !important;
    height: 0.64rem !important;
    .geetest_panel_success_show {
      width: 0.64rem !important;
      height: 0.64rem !important;
    }
  }
  .geetest_panel_success_title {
    margin: 0.2667rem 0 0 0 !important;
  }
}
// Banner
.h5-sempro-banner {
  width: 100%;
  // height: 9.9467rem;
  position: relative;
  padding-top: 1.3333rem;
  .con {
    .title {
      position: absolute;
      font-size: calc(@base-scale*16) !important;
      width: 100%;
      height: calc(@base-scale*44);
      left: calc(@base-scale*30);
      text-align: left !important;
      top: calc(@base-scale*100);
      > p,
      > div {
        width: 100%;
        height: calc(@base-scale*22.4);
        line-height: calc(@base-scale*22.4);
      }
    }
    .des {
      position: absolute;
      font-size: calc(@base-scale*14) !important;
      width: calc(@base-scale*104);
      height: calc(@base-scale*20);
      left: calc(@base-scale*30);
      top: calc(@base-scale*154);
      text-align: left !important;
    }
    .btns {
      position: absolute;
      left: calc(@base-scale*30);
      bottom: calc(@base-scale*84);
    }
  }
}
// Banner下方信息
.banner-bottom {
  width: 100%;
  height: calc(@base-scale*42);
  background: #48494c;
  display: flex;
  margin-top: calc(@base-scale* (-42));
  position: absolute;

  .content {
    display: flex;
    margin: 0 auto;

    .item {
      width: calc(@base-scale*75);
      height: 100%;
      .columnDisplay(center, center);

      .first-line-text {
        color: #edd0a3;
        font-size: calc(@base-scale*10);
      }

      .second-line-text {
        color: #fff;
        font-size: calc(@base-scale*10);
      }
    }

    .item:nth-of-type(odd) {
      background: rgba(94, 93, 93, 0.6);
    }
  }
}
* > img {
  max-width: 100%;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 0;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
// 批量发起
.batch-init-h5 {
  // background-image: url('../../../assets/images/sem-pro/H5/initiate_bg.png');
  background: url('../../assets/images/sem-pro/H5/initiate_bg.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  .batch-title {
    height: calc(@base-scale*22);
    font-size: calc(@base-scale*16);
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: center;
    margin: calc(@base-scale*20) auto calc(@base-scale*8);
  }
  .batch-desc {
    height: calc(@base-scale*20);
    font-size: calc(@base-scale*14);
    font-weight: 400;
    margin: 0 auto calc(@base-scale*20);
    text-align: center;
    color: rgba(153, 153, 153, 1);
  }
  img {
    width: calc(@base-scale*348.72);
    margin: 0 auto;
  }
  .btns-box {
    margin-top: calc(@base-scale*32);
    margin-bottom: calc(@base-scale*32);
    .basisDisplay(center, center);

    .btns {
      display: flex;

      & > div {
        width: calc(@base-scale*86);
        height: calc(@base-scale*32);
        border-radius: calc(@base-scale*4);
        font-size: calc(@base-scale*14);
        cursor: pointer;
        .basisDisplay(center, center);
      }
      div:nth-child(1) {
        margin-right: calc(@base-scale*12);
      }

      .mfsy {
        background: #e63740;
        color: #ffffff;
      }

      .mfsy:hover {
        background: #fb6169;
      }

      .zxzx {
        background: #ffffff;
        box-shadow: 0px 1px 5px 0px rgba(206, 217, 235, 0.74);
        color: #e63740;
      }

      .zxzx:hover {
        color: #fb6169;
      }
    }
  }
}
// api接口开放场景
.api-interface-h5 {
  background-color: #fff;
  overflow: hidden;
  .interface-title {
    height: calc(@base-scale*22);
    font-size: calc(@base-scale*16);
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: center;
    margin: calc(@base-scale*20) auto calc(@base-scale*8);
  }
  .interface-desc {
    height: calc(@base-scale*20);
    font-size: calc(@base-scale*14);
    font-weight: 400;
    margin: 0 auto calc(@base-scale*20);
    text-align: center;
    color: rgba(153, 153, 153, 1);
  }
  img {
    width: calc(@base-scale*348.72);
    margin: 0 auto;
  }
  .btns-box {
    margin-top: calc(@base-scale*32);
    margin-bottom: calc(@base-scale*32);
    .basisDisplay(center, center);

    .btns {
      display: flex;

      & > div {
        width: calc(@base-scale*86);
        height: calc(@base-scale*32);
        border-radius: calc(@base-scale*4);
        font-size: calc(@base-scale*14);
        cursor: pointer;
        .basisDisplay(center, center);
      }
      div:nth-child(1) {
        margin-right: calc(@base-scale*12);
      }

      .mfsy {
        background: #e63740;
        color: #ffffff;
      }

      .mfsy:hover {
        background: #fb6169;
      }

      .zxzx {
        background: #ffffff;
        box-shadow: 0px 1px 5px 0px rgba(206, 217, 235, 0.74);
        color: #e63740;
      }

      .zxzx:hover {
        color: #fb6169;
      }
    }
  }
}
// 销售热线
.sales-hotline {
  height: calc(@base-scale*110);
  background: #e63740;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;

  .title {
    font-weight: 500;
    color: #ffffff;
    line-height: calc(@base-scale*28);
    font-size: calc(@base-scale*20);
  }
  .zxzx {
    width: calc(@base-scale*120);
    height: calc(@base-scale*30);
    border-radius: calc(@base-scale*4);
    font-size: calc(@base-scale*14);
    cursor: pointer;
    .basisDisplay(center, center);
    background: #ffffff;
    box-shadow: 0px 1px 5px 0px rgba(206, 217, 235, 0.74);
    color: #e63740;
    margin-top: calc(@base-scale*18.9);
  }
}
.footer-btns {
  height: calc(@base-scale*60);
  background: #ffffff;
  box-shadow: 0px -2px 6px 0px rgba(221, 221, 221, 0.5);
  display: flex;
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: row;
  z-index: 1;
  .item {
    width: 33.3%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    font-size: calc(@base-scale*14);
    font-weight: 400;
    color: #272727;
  }
  img {
    width: calc(@base-scale*24);
    height: calc(@base-scale*24);
  }
}
.inner-div {
  .agreement-line {
    .wrapper {
      position: relative;
      span {
        margin-left: 0 !important;
        position: absolute;
        left: calc(@base-scale*22);
      }
    }
  }
}
</style>
